import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Formik,Form, Field, useFormikContext } from 'formik';
import { TextField } from 'formik-material-ui';
import { makeStyles, Container, Grid, LinearProgress, Box, Typography, Button, FormControlLabel,FormLabel,Radio,RadioGroup, MenuItem, IconButton, InputAdornment, TableHead, TableRow, TableCell, Table, TableBody, CircularProgress } from '@material-ui/core';
import { List, ListItem, ListItemIcon, ListItemText,Divider  } from '@material-ui/core';
import MuiTextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import {FormikPersistStore} from '../../component/FormikPersistStore'
import { useParams, useRouteMatch } from 'react-router-dom';
import { updateLicenseEdit, saveLicenseEdit, readLicense, clearLicenseEdit, checkLicenseAmt, addLicensePay } from '../../redux/ducks/licenseEditDuck';
import { MyMess, history } from '../../App';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Autocomplete } from 'formik-material-ui-lab';
import { GetMerchants, loadStripeService, QuerySubscriptionPayment } from '../../server/WebServiceUrl';
import Axios from 'axios';
import { checkRequiredHandler } from '../../component/FormUtil';
import { formatNumber, parseDate, formatDate } from '../../utils/WebUIUtil';
import { isAdmin } from '../../utils/Permission';
import { readMerchant } from '../../redux/ducks/merchant';
import { isAlphanumeric, setCookie, getCookie } from '../../utils/Utils';
import { CircularProgressWithLabel } from '../../component/CircularProgressWithLabel';
import LicenseEditConfirmChange from './ConfirmChange/LicenseEditConfirmChange';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {OrangeButton, GreenButton, BlueButton} from '../../component/colorButton';

import QrCode from "../components/QrCode";
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {PAYMENT_METHOD, isCreditCardOnly, isPaymentMethodEnable} from '../../utils/Config';
import { BlurLinear } from '@material-ui/icons';
import queryString from 'query-string';
// var paymAlipayHK = require("../../images/payments/paymAlipayHK.png");
var paymAlipayHK2 = require("../../images/payments/alipay.png");
// var paymWechatPay = require("../../images/payments/paymWechatPay.png");
var paymWechatPay2 = require("../../images/payments/wechat_icon.png");
var paymCreditCard = require("../../images/payments/createcard.png");

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  }));

const FormikRadioGroup = ({
    field,
    form: { touched, errors },
    name,
    options,
    onChange,
    ...props
  }) => {
    const fieldName = name || field.name;
    return (
      <React.Fragment>
        <RadioGroup {...field} {...props} name={fieldName}>
          {options.map(option => (
              <FormControlLabel key={option.value} value={option.value} disabled={option.disabled} control={<Radio  onChange={field.onChange} />} label={option.label}/>
          ))}
        </RadioGroup>
  
        {touched[fieldName] && errors[fieldName] && (
          <React.Fragment>{errors[fieldName]}</React.Fragment>
        )}
      </React.Fragment>
    );
  };

  const CurrencyFormik = () => {
      return (
        <React.Fragment>    
            <Grid item xs={12}>
            <FormLabel component="legend">{MyMess.kopaproLicense.currency.currency}</FormLabel>
                <Field
                    name="cur"
                    row
                    component={FormikRadioGroup}
                    options={[
                        { value:"HKD" ,label: MyMess.kopaproLicense.currency.hkd},
                        { value:"USD" ,label: MyMess.kopaproLicense.currency.usd},
                        { value:"RMB" ,label: MyMess.kopaproLicense.currency.rmb},
                    ]}
                />
            </Grid>
        </React.Fragment>
      )
  }

  const internalKopapro = () => {
    return (
        <React.Fragment>    
            <Grid item xs={12}>
            <FormLabel component="legend">Internal Purpose:</FormLabel>
                <Field
                    name="internal"
                    row
                    component={FormikRadioGroup}
                    options={[
                        { value:"true" ,label: 'Yes'},
                        { value:"false" ,label: 'No'},
                    ]}
                />
            </Grid>
        </React.Fragment>
      )
  }
  
  const activationCodeFormik = (editorState, onClickHandler, onMouseDownHandler, isEnterpriseLicense) => {

    if(editorState.mode !== 'read' || !isEnterpriseLicense) {
        return null;
    }

      return (
        <Grid item xs={12}> 
        <FormLabel component="legend">{MyMess.kopaproLicense.activationCode}</FormLabel>
            <Field                                
            name="activationCode"                                                                                      
            // helperText={MyMess.kopaproLicense.activationCodeHelperText}                                 
            render={
                    (props) => 
                    <TextField        
                        type={editorState.showAC ? 'text' : 'password'}            
                        InputProps={{
                        readOnly: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                aria-label="toggle password visibility"
                                onClick={onClickHandler}
                                onMouseDown={onMouseDownHandler}
                                >
                                {editorState.showAC ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                            </InputAdornment>
                        )
                    }}                                         
                    fullWidth {...props}>
                     
                    </TextField>
                }                                                           
            >                              
               
            </Field>
            {/* <Typography variant="caption" >
                {MyMess.kopaproLicense.activationCodeHelperText}
            </Typography> */}
        </Grid>
      )
  }

  const paymentButtonGroup = (classes, payHandler, historyHandler) => {
      return (
        <Grid item xs={12}>
            <Button                                
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={payHandler}>
            {"Pay Now"}
            </Button>               
        </Grid>
      )
  }

  const merchantCombo = (merchantOptions) => {
      return (
        <Grid item xs={12}>
        <Field
            name="merchantOption"
            //multiple
            component={Autocomplete}
            options={merchantOptions}
            getOptionLabel={(option) => option? (option.label || ''):''}
            getOptionSelected={(option, value) => (option.email === value.email)}
            renderInput={params => (
                <MuiTextField
                {...params}
                //error={touched['autocomplete'] && !!errors['autocomplete']}
                //helperText={touched['autocomplete'] && errors['autocomplete']}
                label={MyMess.merchant.merchant}
                variant="outlined"
                fullWidth
                
                />
            )}
            />
        </Grid>
      )
  }

  const getPlanOptions = (isAdmin, licenseEditInitData) => {

    const isActive = licenseEditInitData.status === 'active';
      let options = [
        { value:"su" ,label: MyMess.kopaproLicense.plan.su}        
        //{value:"et" ,label:MyMess.kopaproLicense.plan.et}        
        ]
        options.push({value:"bu" ,label:MyMess.kopaproLicense.plan.bu });       
    
    options.push({value:"pm" ,label:MyMess.kopaproLicense.plan.pm })

    if(isAdmin)
        options.push({value:"et" ,label:MyMess.kopaproLicense.plan.et})
    return options
  }

  const payHistory = (payments,payHandler) => {

    const parseReason = (descCode,license) => {
        let reasonStr = descCode || '';
        let array = [];
        if(reasonStr.indexOf(';') >= 0){
            const reasons = descCode.split(';');
            reasons.forEach((v,i) => {
                let result = '';
                result += MyMess.kopaproLicense.paymentReason[v] || v;
                if(v === 'KPPPAY_UPDATE_MONTH'){
                    result += license.months + MyMess.kopaproLicense.months
                }

                if(v === 'KPPPAY_UPDATE_YEAR'){
                    result += license.years + MyMess.kopaproLicense.years
                }

                result += '\n';
                array.push(result);
            })
        }else{
            array.push(MyMess.kopaproLicense.paymentReason[descCode] || descCode)
        }
        
        return array;
    }
    const paidHistory = payments.filter(item => item.status === 'paid');

    let records = (
        <TableRow key={'payments_no_record'}>              
            <TableCell align="center" colSpan={3}><Typography>{MyMess.general.noRecord}</Typography> </TableCell>  
        </TableRow>
    );

    if (paidHistory.length) {
        records = paidHistory.sort((a,b)=>(new Date(b.createDate) - new Date(a.createDate))).map((lic) => (
            <TableRow key={lic.uuid}>              
              <TableCell>{parseReason(lic.descCode,lic).map((value,i)=>(<p key={i}>{value}</p>))}</TableCell>
              <TableCell>{parseDate(lic.createDate)}</TableCell>             
              <TableCell align="right">{lic.cur + ' ' + lic.netamt}</TableCell>
              {/* <TableCell align="right">{MyMess.kopaproLicense[lic.status]}</TableCell> */}
            {/* <TableCell align="right">{lic.status == 'pending' && <Button  onClick={e => {payHandler(lic.uuid)}}     color="primary">{MyMess.kopaproLicense.pay}</Button>}</TableCell>                      */}
            </TableRow>
          ));
    }

      return (
        <Table size="small">
        <TableHead>
          <TableRow>            
            <TableCell>{MyMess.kopaproLicense.details}</TableCell>
            <TableCell>{MyMess.kopaproLicense.date}</TableCell>            
            <TableCell align="right">{MyMess.kopaproLicense.netAmt}</TableCell>
            {/* <TableCell align="right">{MyMess.kopaproLicense.status}</TableCell> */}
            {/* <TableCell align="right"></TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {records}
        </TableBody>
        </Table>
      )
  }

  const compareTime = (year, month, compare) => {
      let date = new Date();
      date = new Date(date.getFullYear()+year, date.getMonth()+month, date.getDate());
      return date.getTime() < compare.getTime();
  }

  const getDefaultPeriod = (expDate, isMonthMode) => {
    let date = new Date();
    date = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    // if expired
    if(expDate.getTime() < date.getTime()){
        return 1;
    }

    if(isMonthMode) {

        const monthDiff = (expDate.getFullYear() - date.getFullYear())*12 + (expDate.getMonth() - date.getMonth());

        if (expDate.getDate() < date.getDate()) {
            return monthDiff;
        } else {
            return monthDiff + 1;
        }

    } else {
        let compare = new Date(date.getFullYear(), expDate.getMonth(), expDate.getDate());
        if (date.getTime() > compare.getTime()) {
            return expDate.getFullYear() - date.getFullYear()
        } else {
            return expDate.getFullYear() - date.getFullYear() +1;
        }
    }

  }

  const changePeriod = (editorMode,monthMode, expDate,licStatus) => {
        const shouldDisable = (year,month) => {
            if(editorMode === 'extend'){
                return false;
            }

            // if(licStatus && licStatus === 'pending'){              

            //     return false;
            // }

            return compareTime(year, month, new Date(expDate));
        }

        const getSelect = (isMonthMode) => {
            if(isMonthMode && isMonthMode === 'true'){
                return (
                    <Field
                    component={TextField}
                    type="text"
                    name="months"                                
                    select                                           
                    helperText={MyMess.kopaproLicense.months}                                                                
                    >
                        <MenuItem disabled={shouldDisable(0,1)} value={1}>1</MenuItem>
                        <MenuItem disabled={shouldDisable(0,2)} value={2}>2</MenuItem>
                        <MenuItem disabled={shouldDisable(0,3)} value={3}>3</MenuItem>
                        <MenuItem disabled={shouldDisable(0,4)} value={4}>4</MenuItem>
                        <MenuItem disabled={shouldDisable(0,5)} value={5}>5</MenuItem>
                        <MenuItem disabled={shouldDisable(0,6)} value={6}>6</MenuItem>
                        <MenuItem disabled={shouldDisable(0,7)} value={7}>7</MenuItem>
                        <MenuItem disabled={shouldDisable(0,8)} value={8}>8</MenuItem>
                        <MenuItem disabled={shouldDisable(0,9)} value={9}>9</MenuItem>
                        <MenuItem disabled={shouldDisable(0,10)} value={10}>10</MenuItem>
                        <MenuItem disabled={shouldDisable(0,11)} value={11}>11</MenuItem>
                        <MenuItem disabled={shouldDisable(0,12)} value={12}>12</MenuItem>                    
                    </Field>
                )
            }else{
                return (
                    <Field
                    component={TextField}
                    type="text"
                    name="years"                                
                    select                                           
                    helperText={MyMess.kopaproLicense.years}                                                                
                    >
                        <MenuItem disabled={shouldDisable(1,0)} value={1}>1</MenuItem>
                        <MenuItem disabled={shouldDisable(2,0)} value={2}>2</MenuItem>
                        <MenuItem disabled={shouldDisable(3,0)} value={3}>3</MenuItem>
                        <MenuItem disabled={shouldDisable(4,0)} value={4}>4</MenuItem>
                        <MenuItem disabled={shouldDisable(5,0)} value={5}>5</MenuItem>
                    </Field>
                )
            }
        }

       return (
        <Grid item xs={12}>                 
        <FormLabel component="legend">{editorMode == 'extend' ? MyMess.kopaproLicense.extendPeriod : MyMess.kopaproLicense.period}</FormLabel>
                                                 
            <Field
                name="monthMode"
                component={FormikRadioGroup}                
                row
                options={[{value:'false' ,label: MyMess.kopaproLicense.years},{value:'true' ,label: MyMess.kopaproLicense.months}]}
            />  
            {getSelect(monthMode)}
            
            
        </Grid>
      )
  }


function LicenseEditForm() {    
    const classes = useStyles();

    const validateHandler = (values) => {
        const errors = {};
        let containsError = false;
         checkRequiredHandler(['code','desc'],values,errors);
        // if(values.password != values.repw){
        //     errors.repw = 'Different Password'
        // }       
        // if(!containsError){
        //     dispatch(checkLicenseAmt(checkAmtCallback));
        // }        

        if(values.code && values.code.length > 20){
            errors.code = MyMess.KppResponse.MAX_LENGTH + "(20)" 
        }

        if(values.desc && values.desc.length > 150){
            errors.desc = MyMess.KppResponse.MAX_LENGTH + "(150)" 
        }

        if(values.code && !isAlphanumeric(values.code)){
            errors.code = MyMess.KppResponse.ILLEGAL_ALPHANUMERIC
        }

        return errors;
    }

    
    const [editorState, setEditorState] = useState({
        mode:'edit',
        pending: false,
        showAC: false,
        trial:false,
        monthMode:false                
    })

    const isEditMode = () =>{
        return editorState.mode === 'edit';
    }

    const isExtendMode = () =>{
        return editorState.mode === 'extend';
    }

    const isReadMode = () =>{
        return editorState.mode === 'read';
    }

    const isCreateMode = () =>{
        return editorState.mode === 'create';
    }

    const [showHistory, setShowHistory] = useState(false)
    const [showTasks, setShowTasks] = useState(false)
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [submittingHandler, setSubmittingHandler] = useState(null);

    const [amtState, setAmtState] = useState({
        amt:999.99,
        displayResidue: 0,
        discount: 0,
        netamt:999.99,
        loading:false,
        isRefCodeValid:true   
    })

    const [merchantOptions , setMerchantOptions] = useState([])

    const [paymentHistory, setPaymentHistory] = useState([]);
    const [paymentUuid, setPaymentUuid] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
    const [qrCodeString, setQrCodeString] = useState("");
    const [referenceNo, setReferenceNo] = useState("");

    let licenseEditInitData = useSelector(state => state.licenseEdit);
    let user = useSelector(state => state.user);
    let merchant = useSelector(state => state.merchant);
    let interval;
    const dispatch = useDispatch();
    
    const updateStoreHandler = (data) => {
        if(window.location.href.indexOf('kopapro/read') == -1){
            dispatch(updateLicenseEdit(data));  
        }
        //dispatch(checkLicenseAmt(checkAmtCallback));
    }


    let { path } = useRouteMatch();
    let param = useParams();

    useEffect( () => {     
      
        if(path.indexOf('kopapro/create') >= 0 || path.indexOf('kopapro/trial') >= 0){
            if(path.indexOf('kopapro/trial') >= 0){
                editorState.trial = true;
            }
            editorState.mode = 'create';       
            console.log('start clear');                 
            dispatch(clearLicenseEdit()); 
            handleQueryString();             
            refreshMerchantList(true);  

            checkAmtHandler();
            
            //dispatch(checkLicenseAmt(checkAmtCallback));

        }else{
            if(path.indexOf('kopapro/extend') >= 0){                
                editorState.mode = 'extend';
            }else if(path.indexOf('kopapro/edit') >= 0){
                editorState.mode = 'edit';
            }else{
                editorState.mode = 'read';
            }

            if(param.code){
                asyncReadLicense(param.code);
            }

            if(editorState.mode !== 'read') {

                if (merchant && merchant.isRefCodeUsed) {
                    licenseEditInitData.refCode = merchant.refCode
                }
            }

        }        
        

        return () => {
            
        }
    }, [])

    // useEffect( ()=>{
    //     refreshMerchantList();  

    //     return () => {
            
    //     }
    // },[])

    useEffect(() => {
        
        // paymentUuid exsits means calling payment dialog
        if(formAPI.resetForm && !paymentUuid){
            formAPI.resetForm();     
            
        }

        
    }, [licenseEditInitData.licensePayments,licenseEditInitData.years,licenseEditInitData.monthMode,licenseEditInitData.months])

    useEffect(() => {
        checkAmtHandler()         

        if(licenseEditInitData.newPlan !== 'et'){
            if(formAPI.setFieldValue){
                formAPI.setFieldValue('newSupport','noHotline');
            }
        }

        return () => {}
    }, [licenseEditInitData.plan,licenseEditInitData.support, licenseEditInitData.cur,licenseEditInitData.monthMode,
        licenseEditInitData.months, licenseEditInitData.newSupport,licenseEditInitData.newPlan,licenseEditInitData.years, licenseEditInitData.refCode])

    // useEffect(() => {
    //     console.log('editorState changed');
    //     console.log(editorState);
    // }, [editorState])

    useEffect(() => {
        if(paymentMethod && paymentUuid) {
            dispatch(addLicensePay(payCallback, paymentUuid, paymentMethod));
        }
    },[paymentMethod, paymentUuid]);

    useEffect(() => {
        interval = setInterval(getOrderStatus, 2000);
    
        return function cleanup() {
            if (interval) {
                clearInterval(interval);
            }
        };
    });

    const isPaidBefore = (licensePayments) => {
        if(!licensePayments || typeof licensePayments !== 'object' || licensePayments.length === 0 ) {
          return false
        }
    
        const isFound = licensePayments.find( e => {
          let amount = parseFloat(e.amt);
          return amount > 0 && e.status === 'paid'
        })
        return typeof isFound === 'object'
      }

    const submitHandler =(values, {setSubmitting}) => {   
        let planChanged = false;
        
        if(licenseEditInitData.plan != licenseEditInitData.newPlan){
            planChanged = true;
        }
        
        if(planChanged && editorState.mode == 'edit' && licenseEditInitData.branchComplete){
            setSubmittingHandler(setSubmitting);       
            setOpenConfirmDialog(true);    

        }else{
            doSave();
            setSubmittingHandler(null);     
        }
        
    }

    const doSave = () => {
        
        // if(user.type === 'admin') {
        //     console.log(licenseEditInitData)
        //      return;
        // }
        if(!editorState.trial && (isCreateMode() || isExtendMode()) ) {
            payHandler();
            return;
        }

        startLoadingBar();   
        dispatch(saveLicenseEdit(asaveCallback,editorState.mode, editorState.trial))
    }

    const aextendTrialCallback = (res) => {

        if(res && res.pass){
            GlobalSnackBarUtil.open({
                message:MyMess.general.reloginKppSite                
            })

            dispatch(readMerchant(merchant.code));
        }

        asaveCallback(res);
    }

    const asaveCallback = (res) => {  
        
        stopLoadingBar();
        if(res && res.pass){
           
            if(editorState.trial){
                GlobalSnackBarUtil.open({
                    message:MyMess.general.trialCheckEmail                
                })

                dispatch(readMerchant(merchant.email));
            } else if (isCreateMode() || isExtendMode()) {
                const pendingPayment = res.info.licensePayments.sort((a,b)=>(new Date(b.createDate) - new Date(a.createDate))).find( e => {
                    return e.status == 'pending';
                });
                if (pendingPayment) {
                    setPaymentUuid(pendingPayment.uuid);
                    return;
                }
        
            }

            GlobalSnackBarUtil.open({
                message:MyMess.curd.saveSuccess                
            })

            if(res.info){
                let newCode = res.info.code;                
                history.push('/main/kopapro/');
                history.push('/main/kopapro/read/' + newCode)
            }
        }else{
            
            if(res.error){ 
                let fieldError = {};       
                let dataError = res.error;       
                
                if(dataError.locators && Array.isArray(dataError.locators)){
                 for(let i = 0 ; i < dataError.locators.length ; i++){
                    let loc = dataError.locators[i];
                    fieldError[loc.field] = MyMess.getString("KppResponse." + loc.mess);
                 }          
                 
                 if(formAPI.setSubmitting){
                    formAPI.setSubmitting(false);                         
                }
                 formAPI.setErrors(fieldError);                 
                 //console.log(fieldError);
                }
            }

            if (res.error && res.error.classKey == 'KppEntityError' && res.error.code == 'DUPCODE' ) {
                GlobalSnackBarUtil.open({
                    message:MyMess.KppResponse.DUPSHOP,
                    severity:'error'
                })
            } else {
                GlobalSnackBarUtil.open({
                    message:MyMess.curd.saveFail,
                    severity:'error'
                })
            }

           
        }
    }

    const startLoadingBar = () => {
        setEditorState({
            ...editorState,
            pending: true
        })        
    }

    const stopLoadingBar = () => {
        setEditorState({
            ...editorState,
            pending: false
        })
    }

    const asyncReadLicense = (code) => {
        console.log('read ' + code);
        if(editorState.pending){
            return;
        }
        startLoadingBar();
        dispatch(readLicense(code,readLicenseCallback));
    }

    const immediatePaySnackButton = (payUuid) => (
        <Button color="secondary" onClick={(e) => {payHandler(payUuid)}} size="small">
            {MyMess.general.pay}
        </Button>
    );

    const handleQueryString = (payments) => {
        let qs = queryString.parseUrl(window.location.href);
        if(qs.query.s) {
            let lastPaymentId = qs.query.s;
            let jsonValue = getCookie('p_'+lastPaymentId.replaceAll('-', ''));
            let value = {};
            if(jsonValue && typeof jsonValue === 'object') {
                value = jsonValue;
            }else if( typeof jsonValue === 'string' && jsonValue.length > 0 ) {
                try {
                    value = JSON.parse(jsonValue);
                } catch(e) {
                    console.error(e)
                }
            }
            // console.log(value)
            if(value.code) {
                let {code, desc, plan, support, years, months, cur, monthMode, newPlan, refCode} = value;
                // formAPI.setFieldValue('code', code); 
                // formAPI.setFieldValue('desc', desc); 
                // formAPI.setFieldValue('support', support); 
                // formAPI.setFieldValue('newPlan', newPlan); 
                // formAPI.setFieldValue('cur', cur.toUpperCase()); 
                // formAPI.setFieldValue('months', months); 
                // formAPI.setFieldValue('refCode', refCode); 
                // formAPI.setFieldValue('years', years); 
                if (!monthMode) {
                    monthMode = months > 0 ? 'true': 'false';
                    // formAPI.setFieldValue('monthMode', monthMode); 
                } else {
                    // formAPI.setFieldValue('monthMode',months > 0 ? 'true': 'false'); 
                }
                dispatch(updateLicenseEdit({code, desc, support, years, months, cur, monthMode, newPlan, refCode}));
                // need dispatch more if monthMode changed
                dispatch(updateLicenseEdit({years, months, }));
                

            } else if(payments){
                const lastPayment = payments.find(e => e.uuid === lastPaymentId && e.status !== 'paid' );
                if(lastPayment) {
                    formAPI.setFieldValue('cur',lastPayment.cur.toUpperCase()); 
                    formAPI.setFieldValue('months',lastPayment.months); 
                    formAPI.setFieldValue('refCode',lastPayment.refCode); 
                    formAPI.setFieldValue('years',lastPayment.years); 
                    formAPI.setFieldValue('monthMode',lastPayment.months > 0 ? 'true': 'false'); 
                }
            }
        }
    }

    const readLicenseCallback = (res) => {
       
        if(res && res.data){
            
            if(res.data.shopLicense && res.data.pass){

                const payments = res.data.shopLicense.licensePayments;
                setPaymentHistory(payments);
                formAPI.resetForm();
                handleQueryString(payments);

            }else{
                GlobalSnackBarUtil.open({
                    message: MyMess.kopaproLicense.invalidCode,
                    severity:'error'
                })
                history.push('/main/kopapro');
            }
        }else{
            // GlobalSnackBarUtil.open({
            //     message: MyMess.kopaproLicense.invalidCode,
            //     severity:'error'
            // })
            history.push('/main/kopapro')
        }


        refreshMerchantList();  

        setEditorState({
            ...editorState,
           // mode:'edit',            
            pending: false
        })  
        
        //stopLoadingBar();
    }

    const handleClickShowAC = () => {
        setEditorState({
            ...editorState,
            showAC:!editorState.showAC
        })
      };
    
    const handleMouseDownShowAc= (event) => {
        event.preventDefault();
    };

    const getExpLabelComponent = () => {
        const mode = editorState.mode;
        const isTrial = editorState.trial;

        if(mode === 'extend' || (!isTrial && mode === 'edit') ) {
            return <Typography variant="body1" gutterBottom>{MyMess.kopaproLicense.newExpiryDate}:</Typography>
        } else if (!isTrial && mode === 'create') {
            return <Typography variant="body1" gutterBottom>{MyMess.kopaproLicense.expiryDate}:</Typography>
        }
    
        return null;
      }

      const getResidueValue = () => {

        if (amtState.displayResidue) {
            return licenseEditInitData.cur + ' ' + formatNumber(amtState.displayResidue,2) ;
        } 

       return licenseEditInitData.residueCur + ' ' + formatNumber(licenseEditInitData.residue,2) ;
      }
    
      const getExpValueComponent = () => {

        if (getExpLabelComponent() == null) {
            return null;
        }
        const mode = editorState.mode;
        const isMonthMode = licenseEditInitData.monthMode === 'true';
        const {years, months, expDate} = licenseEditInitData;
        const period = isMonthMode ? months: years;
        let date = licenseEditInitData.systemTime;

        if (mode === 'extend') {
            date = isExpired(expDate) ? new Date() : expDate;
        } 
        return <Typography variant="body1" color="primary" gutterBottom>{getExpDate(date, period, isMonthMode)}</Typography>
      }
      
    const getExpDate = (date, period, monthMode) => {        
        
        if(date instanceof Date){    
        
            let newDate = monthMode ? addMonthToDate(date,period) : addYearToDate(date, period);
            
            return formatDate(newDate);
        }
        return 'N/A'
    }
    function addMonthToDate(date, months) {
        let d = date
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var c = new Date(year , month + months, day);
        return c;
     }

    function addYearToDate(date, years) {
        let d = date
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var c = new Date(year + years, month, day);
        return c;
     }


    const refreshMerchantList = async (setDef) => {        
        startLoadingBar();
        let res = await Axios.get(GetMerchants);        
        if(res && res.status === 200 && res.data && res.data.pass){
            let defMc = {};
          let myData = [];
          myData = res.data.merchants;  
          let merchants = [];    
        
          myData.map((value,index)=>{
            let mc = {        
              
              email: value.email,
              label: value.compName + '(' + value.progCode + ')' + '(' + value.email + ')'
            }
            
            if(value.email === user.email){                        
                if(editorState.mode == 'create'){                      
                    defMc = mc;
                }
            }

            merchants.push(mc);
          })          
          setMerchantOptions(merchants);
          if(setDef)
            licenseEditInitData.merchantOption = defMc;
          stopLoadingBar();
        }else{
          GlobalSnackBarUtil.open({
            message:'Failed to obtain Merchant List',
            severity:'error'
          })
        }
      }


      const checkAmtHandler = () => {
        
        setAmtState({   
            ...amtState,         
            loading:true
        })            
        dispatch(checkLicenseAmt(checkAmtCallback,editorState.mode));
      }

      const checkAmtCallback = (data) => {                
        if(data && data.pass){    
            setAmtState({
                ...amtState,
                amt:data.info.amt * 1.0,
                displayResidue: data.info.displayResidue * 1.0,
                discount: data.info.discamt * 1.0,
                netamt:data.info.netamt * 1.0,
                loading:false,
                isRefCodeValid: true
            })            
        } else {
            setAmtState({
                ...amtState,
                loading:false,
                discount:0,
                netamt: amtState.amt,
                isRefCodeValid: false
            })    
        }

      }

      const getOrderStatus = async () => {
        if (referenceNo) {
            let result = {};
            try{
                result = await Axios.post(QuerySubscriptionPayment,{referenceNo});     
            }catch(e){
                if (e.response && e.response.data && e.response.data.error) {
                    console.error(e.response.data);
                }
            }
            if (result && result.data && result.data.isPaid) {
                history.push('/main/kopapro/read/' + licenseEditInitData.code);
            }
        
        }
     }

      const handleDialogClose = () => {
        // send cancel payment request might be required
        startLoadingBar();

        setOpenPaymentDialog(false);
        stopLoadingBar();
        setQrCodeString('');
        setReferenceNo('');
        setPaymentMethod('');
        setPaymentUuid('');
        if(formAPI.setSubmitting){
            formAPI.setSubmitting(false);                         
        }
        stopLoadingBar();
        // keep modified
        // if(param.code){
        //     asyncReadLicense(param.code);
        // }
    };

    const createPayment = (selectedMethod) => {
        setPaymentMethod(selectedMethod);
        dispatch(saveLicenseEdit(asaveCallback,editorState.mode, editorState.trial))
    
    }

    const getPaymentDialogContent = () => {
        let isShowPayment = referenceNo && qrCodeString;
        if(isShowPayment) {
            return (
                <DialogContent>
                    <DialogContentText>
                        {MyMess.payment.instruction}
                    </DialogContentText>
                    <div>
                    <QrCode
                        qrCode={qrCodeString}
                        qrCodeType={paymentMethod.replace(".qrcode", "")}
                    />
                    </div>
                </DialogContent>
            )
        }
        const isDisable = paymentMethod.length > 0;
        return (
            <DialogContent>
                <DialogContentText>
                    {MyMess.payment.selectMethod}
                </DialogContentText>
                {isCreateMode() && <DialogContentText>
                    <Typography color="secondary">{MyMess.formatString(MyMess.kopaproLicense.createRemindMessage, licenseEditInitData.code.toLowerCase() , 5)}</Typography>
                </DialogContentText>}
                <div style={{display:'flex', flexDirection: 'column'}}>
                    <List>
                        <ListItem 
                            button
                            disabled={isDisable}
                            onClick={() => createPayment(PAYMENT_METHOD.CREDIT_CARD)}
                        >
                        <Box display="flex" justifyContent="center" style={{width:165, paddingRight:15}}>
                            <img style={{width:150}} src={paymCreditCard} />
                        </Box>
                        <ListItemText
                            primary={MyMess.payment.methods.creditCard}
                        />
                        <ListItemIcon>
                            <ArrowForwardIosIcon />
                        </ListItemIcon>
                        </ListItem>
                        {isPaymentMethodEnable(PAYMENT_METHOD.ALIPAY) &&  <Divider /> }
                        {isPaymentMethodEnable(PAYMENT_METHOD.ALIPAY) && 
                        <ListItem 
                            button
                            disabled={isDisable}
                            onClick={() => createPayment(PAYMENT_METHOD.ALIPAY)}
                        >
                            <Box display="flex" justifyContent="center" style={{width:165, paddingRight:15}}>
                                <img src={paymAlipayHK2} />
                            </Box>

                            <ListItemText
                                primary={MyMess.payment.methods.alipay}
                            />
                            <ListItemIcon>
                                <ArrowForwardIosIcon />
                            </ListItemIcon>
                        </ListItem>}
                        {isPaymentMethodEnable(PAYMENT_METHOD.WECHAT_PAY) &&  <Divider /> }
                        {isPaymentMethodEnable(PAYMENT_METHOD.WECHAT_PAY) && 
                        <ListItem 
                            button
                            disabled={isDisable}
                            onClick={() => createPayment(PAYMENT_METHOD.WECHAT_PAY)}
                        >
                            <Box display="flex" justifyContent="center" style={{width:165, paddingRight:15}}>
                                <img src={paymWechatPay2} />
                            </Box>

                            <ListItemText
                                primary={MyMess.payment.methods.wechatPay}
                            />
                            <ListItemIcon>
                                <ArrowForwardIosIcon />
                            </ListItemIcon>
                        </ListItem>}
                    </List>
                </div>
            </DialogContent>
        )
    }

    const payHandler = () => {

        // if(isCreditCardOnly()) {
        //     dispatch(addLicensePay(payCallback, uuid, paymentMethod));
        // } else {
        //     setPaymentUuid(uuid);
        //     setOpenPaymentDialog(true);
        // }

        // always show dialog
        setOpenPaymentDialog(true);
      }
     
      const payCallback = async (resp) => {
        let stripe;
        if (resp && !resp.error) {
            if (paymentMethod == PAYMENT_METHOD.ALIPAY || paymentMethod == PAYMENT_METHOD.WECHAT_PAY) {
                // show dialog  
                setReferenceNo(resp.referenceNo);
                setQrCodeString(resp.qr_code);
                return;
            } 
            stripe = await loadStripeService(resp);
        }
        stopLoadingBar();

        let showError = function() {
            setPaymentMethod('');
            GlobalSnackBarUtil.open({
                message:MyMess.payment.initError,
                severity:'error'
            })
        }

        if (resp && stripe) {
            let  {code, desc, plan, support, years, months, cur, monthMode, newPlan, refCode} = licenseEditInitData;
            let value = {code, desc, plan, support, years, months, cur, monthMode, newPlan, refCode};
            setCookie('p_'+resp.reference_no, JSON.stringify(value))

            stripe
            .redirectToCheckout({
               sessionId: resp.session_id //TODO: fix this
            })
            .then(function (result) {
               console.error(result.error.message);
               showError()
            });

        } else {
            showError();
        }
    }

    const actionHandler = () => {
        history.push('/main/kopapro/');
         history.push('/main/kopapro/extend/' + licenseEditInitData.code);
    }

      const historyHandler = () => {
        //console.log(editorState)
        setShowHistory(!showHistory);

      }

      let formAPI = {
      }

      const initFormAPI = (formProps) => {
        
        formAPI.resetForm = formProps.resetForm;
        formAPI.setErrors = formProps.setErrors;
        formAPI.setSubmitting = formProps.setSubmitting;
        formAPI.setFieldValue = formProps.setFieldValue;
        //console.log(formProps);
        //refreshMerchantList();      
        return true;
      }

      const getPlanLabel = (plan) => {
          return MyMess.kopaproLicense.plan[plan];
      }

      const getSupportLabel = (support) => {
        return MyMess.kopaproLicense.support[support];
    }

    const getEditTitle = (editMode) => {
        switch(editMode){
            case 'create':
                return MyMess.addNewShop
            case 'edit':
                return MyMess.change
            case 'read':
                return MyMess.kopaproLicense.details         
            default:
                const isPaid = isPaidBefore(paymentHistory);
                return isPaid ? MyMess.kopaproLicense.payAndExtend  : MyMess.kopaproLicense.payAndSubscribe      
        }

    }    

    
  const changePlan = (editorMode,planOptions,curPlanLabel,curSupportLabel, value) => {
      
    let supportOptions = [
        { value:"noHotline" ,label: MyMess.kopaproLicense.support.noHotline}       
    ]

    if(licenseEditInitData.newPlan === 'et'){
        supportOptions.push({value:"hotline" ,label:MyMess.kopaproLicense.support.hotline});
    }

    if (editorMode === 'create') {
        return null
    }
    // extend or read
    if(editorMode !== 'edit'){
        return (
            <Grid item xs={12}>
                <Grid item xs={12}>
                    <Box display="flex" >
                        <Box flexDirection="row" m={2}>
                            <Typography variant="body1" gutterBottom>{MyMess.kopaproLicense.plan.oriPlan}: </Typography>
                            {editorMode == 'read' && <Typography variant="body1" gutterBottom>{MyMess.kopaproLicense.support.oriSupport}: </Typography>}
                            <Typography variant="body1" gutterBottom>{MyMess.kopaproLicense.expiryDate}: </Typography>
                        </Box>
                        <Box flexDirection="row" m={2}>
                            <Typography variant="body1" color="primary" gutterBottom>{curPlanLabel}</Typography>
                            {editorMode == 'read' && <Typography variant="body1" color="primary" gutterBottom>{curSupportLabel}</Typography> }
                            <Typography variant="body1" color="primary" gutterBottom>{getExpDate(licenseEditInitData.expDate,0)}</Typography>
                        </Box>
                    </Box>                                                     
                </Grid>  
            </Grid>
        )
    }
    // @deprecated  as no edit mode now
    return (
          <Grid item xs={12}>
              {/* <Grid item xs={12}>                               
                  <FormLabel component="legend">{MyMess.kopaproLicense.plan.oriPlan}</FormLabel>                                             
                  <Typography>{curPlanLabel}</Typography>
              </Grid>  */}
              <Grid item xs={12}>                               
                  <FormLabel component="legend">{MyMess.kopaproLicense.plan.plan}</FormLabel>                                             
                  <Typography variant="body1">{MyMess.kopaproLicense.plan.oriPlan + ': ' + curPlanLabel}</Typography>             
                  <Field
                      defaultValue={value}
                      name="newPlan"
                      component={FormikRadioGroup}                        
                      options={planOptions}
                  />
                  
              </Grid>    
              {/* <Grid item xs={12}>
                  <FormLabel component="legend">{MyMess.kopaproLicense.support.oriSupport}</FormLabel>
                  <Typography>{curSupportLabel}</Typography>
              </Grid>     */}
              <Grid item xs={12}>
                  <FormLabel component="legend">{MyMess.kopaproLicense.support.support}</FormLabel>
                  <Typography variant="body1">{MyMess.kopaproLicense.support.oriSupport + ': ' + curSupportLabel}</Typography>        
                  <Field
                      name="newSupport"
                      component={FormikRadioGroup}
                      options={supportOptions}
                  />
                 
              </Grid>
          </Grid>
        );
    }

    const selectPlan = (planOptions,isTrial, isStartUp) => {    

        const getSupportOptions = () => {
            let supports = [];
            supports.push({ value:"noHotline" ,label: MyMess.kopaproLicense.support.noHotline});
            if(licenseEditInitData.newPlan === 'et'){
                supports.push({value:"hotline" ,label:MyMess.kopaproLicense.support.hotline})
            }

            return supports;
        }

        return (<Grid item xs={12}>
            
            <Grid item xs={12}>                               
                <FormLabel component="legend">{MyMess.kopaproLicense.plan.plan}</FormLabel>                                             
                <Field
                    name="newPlan"
                    component={FormikRadioGroup}
                    row
                    options={planOptions}
                />                
            </Grid>                           
            {!isTrial && 
                <Grid item xs={12}>
                    <FormLabel component="legend">{MyMess.kopaproLicense.support.support}</FormLabel>
                    <Field
                        name="newSupport"
                        component={FormikRadioGroup}
                        options={getSupportOptions()}
                    />
                </Grid>
            }
        </Grid>);
    }

    const isExpired = (expDate) => {
        if(expDate && new Date(expDate).getTime() - (new Date()).getTime() < 0){
            return true;
        }

        return false;
    }

    const extendTrialHandler = () => {

        dispatch(saveLicenseEdit(aextendTrialCallback,'extend', editorState.trial, true))
    }

    const licTaskRenderer = () => {  
        let tasks = licenseEditInitData.licenseTasks;

        

          return (
            <Table size="small">
            <TableHead>
              <TableRow>                           
                <TableCell >{MyMess.kopaproLicense.details}</TableCell> 
                <TableCell>{MyMess.kopaproLicense.createDate}</TableCell>                           
                <TableCell align="right">{MyMess.kopaproLicense.status}</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.sort((a,b)=>(new Date(b.createDate) - new Date(a.createDate))).map((lic) => (
                <TableRow key={lic.uuid}>                                
                    <TableCell >{MyMess.kopaproLicense.task[lic.taskCode]}</TableCell>
                  <TableCell>{parseDate(lic.createDate)}</TableCell>    
                  <TableCell align="right"> 
                    {
                    lic.status !== 'running' && MyMess.kopaproLicense[lic.status]
                    }
                    {
                    lic.status == 'running' && <CircularProgressWithLabel  value={lic.progressVal} text={MyMess.kopaproLicense[lic.status]}/>
                    }
                </TableCell>
                  
                <TableCell align="right"></TableCell>                     
                </TableRow>
              ))}
            </TableBody>
            </Table>
          )
      }

    const isShowAmountFormik = !editorState.trial && user.type === 'merchant' && editorState.mode !== 'read';
    
    return (
        <Container>
        <Formik
        initialValues={{...licenseEditInitData}}        
        validate={validateHandler}  
        onSubmit={submitHandler}
        //enableReinitialize={true}
        >
            {(formProps) => (                
                <Container component="main" maxWidth="xs">
                    {editorState.pending  && <LinearProgress />}
                    <Paper m={2} elevation={3} square>       
                    <Box m={3}>       
                    <Form className={classes.form} >
                        {initFormAPI(formProps)}
                        {!editorState.pending && 
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                            <Typography component="h2" variant="h6" style={{textTransform:'uppercase'}} color="primary" gutterBottom>
                                {getEditTitle(editorState.mode)}
                            </Typography>
                            </Grid>
                            {user.type == 'admin' && merchantCombo(merchantOptions)}
                            {!merchant.trialCreated && editorState.mode === 'create' && !editorState.trial &&
                                <Grid item xs={12}>
                                    <Typography variant="body1" color="textPrimary" component="p">
                                    {MyMess.dashboard.addTrial.msg}           
                                    </Typography>
                                    <Typography variant="body1" color="textPrimary" component="p">
                                    {MyMess.dashboard.addTrial.msg2}           
                                    </Typography>
                                    <Button                                
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={() => { history.push('/main'); setTimeout(()=>{history.push('/main/kopapro/trial')},1)}}                                
                                >
                                    {MyMess.dashboard.addTrial.action1}
                                    </Button>
                                    <Typography variant="body1" color="textPrimary" component="p">                                        
                                    {MyMess.subDirectly}
                                    </Typography>

                                </Grid>
                            }
                            <Grid item xs={12}> 
                            {user.type == 'admin' && <Field                                
                                name="m18ProxyId"                                
                                render={(props,form) => 
                                    <TextField                                     
                                    inputProps={{ style: { textTransform: "lowercase" } }}
                                    disabled={editorState.mode !== 'create'}                                    
                                    label={'M18 Proxy ID'}                                    
                                    fullWidth {...props}/>}                                
                                />}                   
                                <Field                                
                                name="code"                                
                                render={(props,form) => 
                                    <TextField                                     
                                    required
                                    inputProps={{ style: { textTransform: "lowercase" } }}
                                    disabled={editorState.mode !== 'create'}                                    
                                    label={MyMess.kopaproLicense.code}                                    
                                    fullWidth {...props}/>}                                
                                    
                                ></Field>
                                <Typography variant="caption" >
                                    {MyMess.kopaproLicense.codeHelperText}
                                </Typography>  
                            </Grid>
                            <Grid item xs={12}>                
                                <Field
                                
                                name="desc"                                
                                render={(props) => 
                                    <TextField                                     
                                    required
                                    disabled={editorState.mode !== 'create'}   
                                    label={MyMess.kopaproLicense.desc}
                                    fullWidth {...props}/>}          
                                />        
                                <Typography variant="caption" >
                                    {MyMess.kopaproLicense.descHelperText}
                                </Typography>          
                            </Grid>

                            {!isReadMode() && !editorState.trial && !merchant.isRefCodeUsed && <Grid item xs={12}> 
                                             
                                <Field                                
                                name="refCode"                                
                                render={(props,form) => 
                                    <TextField     
                                    error={!amtState.isRefCodeValid}                         
                                    helperText={amtState.isRefCodeValid? "":MyMess.kopaproLicense.invalidRefCode}         
                                    inputProps={{ style: { textTransform: "uppercase" } }}
                                    // disabled={editorState.mode !== 'create'}                                    
                                    label={MyMess.kopaproLicense.refCode}                                    
                                    fullWidth {...props}/>}                                
                                    
                                ></Field>                                
                            </Grid>}
                           
                            
                            {editorState.mode === 'create'  && selectPlan(getPlanOptions(user.type === 'admin', licenseEditInitData),editorState.trial,licenseEditInitData.newPlan === 'su' )}

                            {changePlan(editorState.mode,getPlanOptions(user.type === 'admin', licenseEditInitData),getPlanLabel(licenseEditInitData.plan),getSupportLabel(licenseEditInitData.support),licenseEditInitData.newPlan)}
                            {activationCodeFormik(editorState, handleClickShowAC, handleMouseDownShowAc, licenseEditInitData.newPlan === 'et')}

                            {(editorState.mode !== 'read' && !editorState.trial) && changePeriod(editorState.mode, licenseEditInitData.monthMode, licenseEditInitData.expDate,licenseEditInitData.status)}
                            {user.type === 'admin' && internalKopapro()}
                             {!editorState.trial && user.type === 'merchant' && editorState.mode !== 'read' && CurrencyFormik() }
                                                      
                            <Grid item xs={12}>
                                <Box display="flex" >
                                    <Box flexDirection="row" m={2}>
                                        {getExpLabelComponent()}
                                        {false && !editorState.trial && isExtendMode() && isPaidBefore(paymentHistory) && <Typography variant="body1" gutterBottom>{MyMess.kopaproLicense.residue}:</Typography> }
                                        {isShowAmountFormik && <Typography  variant="body1" gutterBottom>{MyMess.kopaproLicense.amt}:</Typography> }
                                        {isShowAmountFormik && amtState.discount > 0 && <Typography  variant="body1" gutterBottom>{MyMess.kopaproLicense.discount}:</Typography> }
                                        {isShowAmountFormik && <Typography  variant="body1" gutterBottom>{MyMess.kopaproLicense.netAmt}:</Typography> }
                                    </Box>
                                    <Box flexDirection="row" m={2}>
                                        {getExpValueComponent()}  
                                        {false && !editorState.trial && isExtendMode() && isPaidBefore(paymentHistory) &&
                                            <Typography variant="body1" color="primary" gutterBottom>
                                                {getResidueValue()}       
                                            </Typography>
                                        }
                                        {isShowAmountFormik && <Typography variant="body1" color="primary" gutterBottom>{amtState.loading? MyMess.loading :`${licenseEditInitData.cur} ${formatNumber(amtState.amt,2)}`}</Typography> }
                                        {isShowAmountFormik  && amtState.discount > 0 && <Typography variant="body1" color="primary" gutterBottom>{amtState.loading? MyMess.loading :`${licenseEditInitData.cur} ${formatNumber(amtState.discount,2)}`}</Typography> }
                                        {isShowAmountFormik && <Typography variant="body1" color="primary" gutterBottom>{amtState.loading? MyMess.loading : `${licenseEditInitData.cur} ${formatNumber(amtState.netamt,2)}`}</Typography> }
                                    </Box>
                                </Box>                                                     
                            </Grid>

                            { editorState.mode !== 'read' && licenseEditInitData.isTrial && !licenseEditInitData.trialExtended && isExpired(licenseEditInitData.expDate) &&
                                <Button                                
                                fullWidth
                                variant="contained"
                                color="primary"            
                                               
                                className={classes.submit}
                                onClick={extendTrialHandler}                                
                                >
                                    {MyMess.kopaproLicense.extendTrial}
                                </Button>
                            }    
                            
                            { editorState.mode !== 'read' &&
                            <OrangeButton                                
                                fullWidth
                                variant="contained"
                                color="primary"            
                                type="submit"   
                                disabled={!amtState.isRefCodeValid}                 
                                className={classes.submit}
                                //onClick={submitHandler}                                
                            >
                                {editorState.trial ? MyMess.curd.save : MyMess.general.pay}
                            </OrangeButton>
                            }
                             {isReadMode() &&
                                <OrangeButton                                
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={actionHandler}                                
                                >
                                    {isPaidBefore(paymentHistory) ? MyMess.extend  : MyMess.kopaproLicense.payAndSubscribe }
                                </OrangeButton>
                            }

                            {!editorState.trial && 
                                <Button                                
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={() => { history.push('/main/kopapro')}}                                
                                >
                                    {MyMess.back}
                                </Button>
                            }
                            {isReadMode() &&
                                <Button                                
                                    fullWidth
                                    color="primary"
                                    className={classes.submit}
                                    onClick={historyHandler}
                                    endIcon={showHistory?<ArrowDropUpIcon />: <ArrowDropDownIcon />}                                
                                >
                                    {MyMess.subscriptionHistory}
                                </Button>
                            }

                            {isAdmin(user.type) &&editorState.mode !== 'create' &&
                                <Button                                
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={() => {
                                        setShowTasks(!showTasks)
                                    }}                                
                                >
                                    {MyMess.kopaproLicense.showServerTask}
                                </Button>
                            }

                            

                            
                        </Grid>
                        }  
                        <FormikPersistStore name="licenseEditForm" handler={updateStoreHandler}></FormikPersistStore>
                    </Form>    
                    </Box>   
                    </Paper>  
                </Container>
                
            )}
             
        </Formik>
        
        { editorState.mode !== 'create' && showHistory && paymentHistory.length > 0 && payHistory(paymentHistory,payHandler)}
        { editorState.mode !== 'create' && showTasks && licenseEditInitData.licenseTasks.length > 0 && licTaskRenderer()}

        <LicenseEditConfirmChange       
          id="ringtone-menu"
          classes={{
            paper: classes.paper,
          }}
          keepMounted
          open={openConfirmDialog} 
          onConfirm={
            () => {
                setOpenConfirmDialog(false);
                doSave();
            }
          }
          onCancel={
              ()=>{
                  if (submittingHandler) {
                    // set submitting event to false
                    submittingHandler(false);
                  }
                  setOpenConfirmDialog(false);
              }
          }

          oPlan={licenseEditInitData.plan}
          nPlan={licenseEditInitData.newPlan}
        />   
        <Dialog disableBackdropClick disableEscapeKeyDown onClose={handleDialogClose} aria-labelledby="license-dialog-title" open={openPaymentDialog}>
                <DialogTitle id="license-dialog-title"> {MyMess.payment.title}</DialogTitle>
                {getPaymentDialogContent()}
                
                <DialogActions>
                <Button onClick={handleDialogClose} disabled={paymentMethod == 'creditcard' && paymentUuid} color="primary">
                    {MyMess.general.cancel}
                </Button>
                </DialogActions>
            </Dialog>
        </Container>
        
        
    )
}

export default LicenseEditForm;
